<template>
  <v-card
    flat
    :class="{
      'compact': compact,
      'device-cards-container': !isMobileBreakpoint,
      'device-cards-mobile': isMobileBreakpoint,
    }"
  >
    <div class="d-flex align-center mb-1">
      <span class="d-flex text-center body-label-caption neutral-40-light--text">
        {{ item.label }}
        <v-tooltip v-if="item.tooltip" max-width="200px" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-on="on"
              v-bind="attrs"
              size="12"
              class="ml-1 neutral-70--text"
              style="margin-bottom: 2px"
            >
              mdi-information
            </v-icon>
          </template>
          <span>{{ item.tooltip }}</span>
        </v-tooltip>
      </span>
    </div>

    <span
      v-if="!loading"
      class="neutral-20-dark--text"
      :class="'body-bold-xlarge '"
    >
      {{ item.value }}
    </span>

    <span v-else class="d-flex flex-column align-center">
      <v-skeleton-loader
        type="image"
        class="mt-5 rounded-lg"
        width="84px"
        height="29px"
      />
  
      <v-skeleton-loader
        v-if="!oneRowLoading"
        type="image"
        class="mt-1 rounded-lg"
        width="32px"
        height="18px"
      />
    </span>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ResumeCard',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        label: 'lorem ipsum',
        tooltip: 'lorem ipsum',
        value: 1234,
      }),
    },
    compact: {
      type: Boolean,
      default: false,
    },
    oneRowLoading: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
  }
}
</script>

<style lang="scss" scoped>
.device-cards-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: varFigma(neutral-99);
  padding: 24px;
  height: 152px;
  border-radius: 8px;
}

.device-cards-mobile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: varFigma(neutral-99);
  padding: 10px;
  height: 152px;
  border-radius: 8px;
}

.compact {
  height: 98px;
}
</style>
